import { Mail, Clock } from "lucide-react";
import { CONTACT_EMAIL } from "@/data/content";

const InfoCard = ({ icon: IconCmp, title, children }) => (
  <div className="rounded-2xl border border-[color:rgba(10,27,51,0.12)] bg-white p-6">
    <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--ibp-navy-900)] text-[#E7BE4A]">
      <IconCmp className="h-5 w-5" />
    </span>
    <h3 className="mt-4 font-[var(--font-heading)] text-base font-semibold text-[var(--ibp-ink)]">
      {title}
    </h3>
    {children}
  </div>
);

export const ContactInfo = () => (
  <div className="space-y-5">
    <InfoCard icon={Mail} title="Email us">
      <a
        href={`mailto:${CONTACT_EMAIL}`}
        className="mt-1 block text-sm font-medium text-[#0F3D8A] hover:underline"
      >
        {CONTACT_EMAIL}
      </a>
    </InfoCard>
    <InfoCard icon={Clock} title="Response time">
      <p className="mt-1 text-sm text-[color:rgba(11,18,32,0.68)]">
        We aim to reply within 1–2 business days. For refund reviews, please
        contact us within 7 days of purchase.
      </p>
    </InfoCard>
  </div>
);

export default ContactInfo;
